import { useMemo } from "react";
import dayjs from "dayjs";

function toMinute(t) {
  if (!t) return 0;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}

function buildMinuteLabels(startMinute, endMinute) {
  const labels = [];
  for (let i = startMinute; i <= endMinute; i++) {
    const hh = String(Math.floor(i / 60)).padStart(2, "0");
    const mm = String(i % 60).padStart(2, "0");
    labels.push(`${hh}:${mm}`);
  }
  return labels;
}

export function useSocialMinuteCompare({
  rawVideo,
  youtubeData,
  twitterData,
  selectedDate,
  startTime,
  endTime,
}) {
  return useMemo(() => {

    if (!selectedDate) return [];

    const startMinute = toMinute(startTime);
    const endMinute = toMinute(endTime);
    if (endMinute < startMinute) return [];

    const labels = buildMinuteLabels(startMinute, endMinute);

    const key = dayjs(selectedDate, "YYYY-MM-DD").format("DD-MM-YYYY");

    const tvArr = Array.isArray(rawVideo?.[key]) ? rawVideo[key] : [];

    const tvValues = tvArr
      .slice(startMinute, endMinute + 1)
      .map((v) => Math.round((Number(v) || 0) / 2));


    /* =========================
       YOUTUBE (FIXED)
    ========================= */

    const ytArr = Array.isArray(youtubeData?.[key])
      ? youtubeData[key]
      : [];

    const ytValues = ytArr.length
      ? ytArr
          .slice(startMinute, endMinute + 1)
          .map((v) => Number(v) || 0)
      : new Array(labels.length).fill(0);


    /* =========================
       TWITTER / X (FIXED)
    ========================= */

    const xArr = Array.isArray(twitterData?.[key])
      ? twitterData[key]
      : [];

    const xValues = xArr.length
      ? xArr
          .slice(startMinute, endMinute + 1)
          .map((v) => Number(v) || 0)
      : new Array(labels.length).fill(0);


    return [
      {
        name: "Avg Active",
        data: tvValues.map((v, i) => ({
          x: labels[i],
          active: v,
        })),
      },
      {
        name: "YouTube",
        data: ytValues.map((v, i) => ({
          x: labels[i],
          active: v,
        })),
      },
      {
        name: "Twitter/X",
        data: xValues.map((v, i) => ({
          x: labels[i],
          active: v,
        })),
      },
    ];
  }, [
    rawVideo,
    youtubeData,
    twitterData,
    selectedDate,
    startTime,
    endTime,
  ]);
}
